import { render } from "./contactEdit.vue?vue&type=template&id=2776553c&scoped=true"
import script from "./contactEdit.vue?vue&type=script&lang=js"
export * from "./contactEdit.vue?vue&type=script&lang=js"

import "./contactEdit.vue?vue&type=style&index=0&id=2776553c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2776553c"

export default script